import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { NavigationService } from '../../../services/navigation.service';
import { SearchService } from 'src/app/shared/services/search.service';
import { StorageService } from '../../../services/storage.service';
import { Router, RouteConfigLoadStart, ResolveStart, RouteConfigLoadEnd, ResolveEnd } from '@angular/router';

@Component({
  selector: 'app-admin-layout-sidebar-plain',
  templateUrl: './admin-layout-sidebar-plain.component.html',
  styleUrls: ['./admin-layout-sidebar-plain.component.scss'],
  standalone: false
})
export class AdminLayoutSidebarPlainComponent implements OnInit, OnDestroy {
  moduleLoading: boolean;

  constructor(
    public navService: NavigationService,
    public searchService: SearchService,
    private router: Router,
    private storageService: StorageService
  ) { }

ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
        this.moduleLoading = true;
      }
      if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        this.moduleLoading = false;
      }
    });
    
  // Filter menu based on user role (handles page refresh)
  const user = this.storageService.getUser();

  if (user && user.roles && user.roles.length > 0) {
    this.navService.publishNavigationChange(user.roles[0]);
  }

    // Check screen size on init
    this.checkScreenSize();
}
  
  ngOnDestroy() {
    // Clean up any subscriptions if needed
  }
  
  // Listen for window resize events
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }
  
  // Check screen size and update sidebar state
  checkScreenSize() {
    if (window.innerWidth < 768) {
      // Close sidebar on mobile
      this.navService.sidebarState.sidenavOpen = false;
    }
  }
  
  // Toggle sidebar open/close state
  toggleSidebar() {
    this.navService.sidebarState.sidenavOpen = !this.navService.sidebarState.sidenavOpen;
  }
}
